import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const OnboardingRoute = ({ element }) => {
    const { isAuth, StatusDocument } = useContext(AuthContext);

    // Si el usuario está autenticado y cumple con el requisito de Onboarding, muestra el elemento
    if (isAuth && StatusDocument !== "APPROVED") {
        return element;
    }
    if (isAuth && StatusDocument == "APPROVED") {
        return <Navigate to="/dashboard" />;
    }

    // Si está autenticado pero no cumple el requisito de Onboarding, lo redirige a Splash
    if (isAuth) {
        return <Navigate to="/splash" />;
    }

    // Si no está autenticado, lo redirige a Login
    return <Navigate to="/login" />;
};

export default OnboardingRoute;
